// extracted by mini-css-extract-plugin
export default {"title":"yzf5LMVM4CrYyo_3nE7r"};